import { apiPost } from '../utils/apiClient';
import useAsyncData from './useAsyncData';

/**
 * Reusable hook to resolve an array of document IDs into lightweight metadata
 * (id, file_name, document_type, mime_type).
 *
 * Usage:
 *   const { documents, loading } = useDocumentSummaries(proof_document_ids);
 *   // documents = [{ id: 1, file_name: "Proof.pdf", document_type: "kyc", mime_type: "..." }, ...]
 *
 * @param {number[]|null} ids - Array of document IDs to resolve
 * @returns {{ documents: Array, loading: boolean, error: string|null, reload: Function }}
 */
const useDocumentSummaries = (ids) => {
  const hasIds = Array.isArray(ids) && ids.length > 0;

  const { data: documents, loading, error, reload } = useAsyncData(
    () => hasIds ? apiPost('/admin/documents/batch-summary', { ids }) : Promise.resolve({ data: [] }),
    {
      defaultValue: [],
      fetchOnMount: hasIds,
      deps: [JSON.stringify(ids)],
    }
  );

  return { documents, loading, error, reload };
};

export default useDocumentSummaries;
